import { API_ROOT } from '../../constants';

export const PAYMENT_SESSION_URL = `${API_ROOT}/public/payment-solution/apple/payment-session`;
export const PAY_URL = `${API_ROOT}/public/payment-solution/apple/pay`;



// WEBPACK FOOTER //
// ./src/services/applepay/constants.js